import { render, staticRenderFns } from "./qs4-05.vue?vue&type=template&id=edc111c8&scoped=true&"
import script from "./qs4-05.vue?vue&type=script&lang=js&"
export * from "./qs4-05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc111c8",
  null
  
)

export default component.exports